import { TableColumn } from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { ViewEmployee } from "../../Types/Workforce/201File";
import { Badges, Btn } from "../../AbstractElements";
import { FileText } from "react-feather";

// ============================================================
// TYPES
// ============================================================
import { CRUDPermissions } from "../../Types/Common/Access";

interface BadgeProps {
  label: string;
  color: string;
}

const CustomBadge: React.FC<BadgeProps> = ({ label, color }) => (
  <Badges style={{ width: "105px" }} color={color}>
    {label}
  </Badges>
);

const ActionCell = ({
  row,
  access,
}: {
  row: ViewEmployee;
  access: CRUDPermissions;
}) => {
  const navigate = useNavigate();

  const encoded = btoa(row.emp_no.toString());

  const handleView = () => {
    navigate(
      `${process.env.PUBLIC_URL}/workforce/employee/${encodeURIComponent(encoded)}`,
      {
        state: {
          access,
        },
      },
    );
  };

  return (
    <Btn color="primary" size="sm" onClick={handleView}>
      <FileText size={11} /> View
    </Btn>
  );
};

const employmentStatusColors: Record<string, string> = {
  "1": "info",
  "2": "success",
  "3": "secondary",
  "4": "danger",
  "5": "danger",
  "6": "danger",
  "7": "danger",
};

export const EmployeeTableColumn = (
  access: CRUDPermissions,
): TableColumn<ViewEmployee>[] => [
  {
    name: "EMPLOYEE NO",
    selector: (row) => row.emp_no,
    sortable: true,
    width: "150px",
  },
  {
    name: "EMPLOYEE DETAILS",
    selector: (row) => row.full_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        <b>{row.full_name}</b>
        {"\n"}
        {row.job_title}
      </div>
    ),
    sortable: true,
    width: "500px",
  },
  {
    name: "EMPLOYMEE STATUS",
    selector: (row) => row.employment_status,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        <CustomBadge
          color={employmentStatusColors[row.employment_status] || "secondary"}
          label={row.employment_status_label.toUpperCase()}
        />
      </div>
    ),
    sortable: true,
    center: true,
    width: "180px",
  },
  {
    name: "EMPLOYMENT TYPE",
    selector: (row) => row.employment_type,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        <CustomBadge
          color={"primary"}
          label={row.employment_type.toUpperCase()}
        />
      </div>
    ),
    sortable: true,
    center: true,
  },
  {
    name: "DATE CREATED",
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.created_by_user}
        {"\n"}
        {row.created_at}
      </div>
    ),
    sortable: true,
  },
  {
    name: "DATE MODIFIED",
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_at}
      </div>
    ),
    sortable: true,
  },
  {
    name: "ACTION",
    sortable: false,
    cell: (row) => <ActionCell row={row} access={access} />,
    center: true,
  },
];
